// 导入axios接口
import axiosRequest from '@/utils/axios-default-request';

let addEvaluate = (data) => axiosRequest.postBodyJson('/clientinterface/addEvaluate', data);
let getEvaluateList = (data) => axiosRequest.postBodyJson('/clientinterface/getEvaluateList', data);

// 译员端------------------------------------------------------------------------------------------------
// 获取订单详情 译员
let addEvaluateYY = (data) => axiosRequest.postBodyJson('/supinterface/addEvaluate', data);
let getEvaluateListYY = (data) => axiosRequest.postBodyJson('/supinterface/getEvaluateList', data);

export default {
    addEvaluate,//获取订单详情
    getEvaluateList,
    // 译员端------------------
    addEvaluateYY,
    getEvaluateListYY,
}